import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GroupsIcon from "@mui/icons-material/Groups";
import { Box, Card, CardContent, Chip, Divider, Stack, Typography, } from "@mui/material";
import { Link } from "react-router-dom";
import { EmptyState } from "../common/EmptyState";
import { TeamAvatar } from "./TeamAvatar";
var MAX_TEAMS_TO_SHOW = 5;
export var TeamsCard = function (_a) {
    var teams = _a.teams, isOwnProfile = _a.isOwnProfile;
    var showViewAll = teams.length > MAX_TEAMS_TO_SHOW;
    var teamsToDisplay = teams.slice(0, MAX_TEAMS_TO_SHOW);
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 2,
                    }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "Teams" }), teams.length > 0 && (_jsx(Chip, { label: teams.length, size: "small", sx: {
                                backgroundColor: "rgba(25, 118, 210, 0.1)",
                                color: "primary.main",
                                fontWeight: 600,
                                minWidth: 24,
                            } }))] }), _jsx(Divider, { sx: { mb: 2 } }), _jsx(Stack, { spacing: 0, sx: { width: "100%" }, children: teamsToDisplay.length > 0 ? (teamsToDisplay.map(function (team, index) { return (_jsx(Link, { to: "/teams/".concat(team.id, "/"), style: {
                            textDecoration: "none",
                            color: "inherit",
                            width: "100%",
                        }, children: _jsxs(Box, { sx: {
                                py: 1.5,
                                px: 2,
                                display: "flex",
                                alignItems: "center",
                                "&:hover": {
                                    backgroundColor: "#f8f9ff",
                                },
                                transition: "all 0.2s ease",
                                borderBottom: index < teamsToDisplay.length - 1
                                    ? "1px solid rgba(0,0,0,0.08)"
                                    : "none",
                            }, children: [_jsx(TeamAvatar, { team: team }), _jsx(Typography, { variant: "body1", sx: { ml: 2, fontWeight: 600 }, children: team.name })] }) }, team.id)); })) : (_jsx(EmptyState, { icon: _jsx(GroupsIcon, {}), heading: "No teams yet", description: isOwnProfile ? "Create a team to get started." : undefined, actionLabel: isOwnProfile ? "Create Team" : undefined, actionTo: isOwnProfile ? "/teams/create/" : undefined })) }), showViewAll && (_jsx(Box, { sx: {
                        p: 2,
                        textAlign: "center",
                        backgroundColor: "rgba(25, 118, 210, 0.02)",
                        borderTop: "1px solid rgba(0,0,0,0.08)",
                        mt: 1,
                    }, children: _jsx(Link, { to: "/teams", style: { textDecoration: "none" }, children: _jsxs(Typography, { variant: "body2", sx: {
                                color: "primary.main",
                                fontWeight: 500,
                                "&:hover": {
                                    textDecoration: "underline",
                                },
                            }, children: ["View all ", teams.length, " teams \u2192"] }) }) }))] }) }));
};
